import { Component, computed, input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AvatarModule } from "primeng/avatar";
import { SubscriptionPlans } from "../../data/enums.data";
import { SubscriptionPlansOptions } from "../../data/utils.data";
import { BadgeModule } from "primeng/badge";
import { TooltipModule } from 'primeng/tooltip';
@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.css',
  imports: [CommonModule, AvatarModule, BadgeModule, TooltipModule],
  host: { style: 'display: contents' },
})
export class UserAvatarComponent implements OnInit {
  imageUrl = input.required<string>();
  subscriptionPlan = input<SubscriptionPlans>(SubscriptionPlans.None);
  size = input<'normal' | 'large' | 'xlarge' | 'xxlarge'>('normal');
  subscriptionEnum = SubscriptionPlans;
  hasImage = computed(() => this.imageUrl().startsWith('http'));

  primengSize = computed(() => {
    const currentSize = this.size();
    return currentSize === 'xxlarge' ? 'xlarge' : currentSize;
  });
  
   hasSubscription = computed(() => 
    this.subscriptionPlan() !== SubscriptionPlans.None && 
    this.subscriptionPlan() !== null &&
    this.subscriptionPlan() !== undefined
  );

  planOption = computed(() => 
    SubscriptionPlansOptions.find(plan => plan.value === this.subscriptionPlan())
  );

  iconAvatarStyle = computed(() => ({
    'background-color': 'white',
    color: '#c46502',
  }));

  ngOnInit(): void {
  }
}